import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_ANAGRAFICA } from '../../data.const';
import {
  setCurrentAnagraficaAction,
  setCurrentUserAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const retrieveAnagraficaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_ANAGRAFICA),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_ANAGRAFICA}]`, p)),
    withLatestFrom(state$),
    switchMap(([id, _state]) => {
      return concat(
        of(setLoaders({ anagraficaLoader: true })),
        defer(() =>
          from(
            request({ path: `anagrafica/${id}`, method: httpMethods.GET })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p?.result;
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_ANAGRAFICA}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(p => of(setCurrentAnagraficaAction(p))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_ANAGRAFICA}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ anagraficaLoader: false }))
      );
    })
  );

export default retrieveAnagraficaEpic;
